import { VFlow } from 'bold-ui'

import { NewsHeadingSection } from '../components/NewsHeadingSection'
import { NewsListItem } from '../components/NewsListItem'

export function NewsInternalEstabilizacaoV55() {
  return (
    <VFlow>
      <NewsHeadingSection title='Versão 5.5.24' id='estabilizacao-5-5-24'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Ajuste de erro em que alguns imóveis não estavam sendo exibidos corretamente no CDS.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde não estava sendo possível realizar a atualização do sistema em algumas instalações.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.5.23' id='estabilizacao-5-5-23'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Reorganização do acesso aos módulos de Cadastro individual e Acompanhamento do território.
          </NewsListItem>
          <NewsListItem>Criação do novo perfil padrão no e-SUS com o nome Mediador intercultural.</NewsListItem>
          <NewsListItem>
            Inclusão de informações complementares dos fabricantes de vacinas para facilitar sua identificação nos
            registros de vacinação.
          </NewsListItem>
          <NewsListItem>Inclusão do campo CID-10 no módulo de Antecedentes familiares.</NewsListItem>
          <NewsListItem>Reorganização no fluxo de configuração do painel de chamadas.</NewsListItem>
          <NewsListItem>
            Atualização das regras de faixa etária e aprazamento para o registro da aplicação do imunobiológico "Pneumo
            20".
          </NewsListItem>
          <NewsListItem>
            Atualização dos campos e regras de validação para suportar o novo formato de CNPJ alfanumérico, em
            conformidade com a Instrução Normativa 2.229 da Receita Federal.
          </NewsListItem>
          <NewsListItem>
            Priorização do CPF como chave principal do cidadão no Atendimento Domiciliar e no Cadastro Domiciliar e
            Territorial do CDS, tornando o preenchimento do CNS habilitado apenas se o cidadão não possuir CPF.
          </NewsListItem>
          <NewsListItem>
            Correção de erro na Lista de atendimentos em que a equipe responsável não era carregada ao editar um
            atendimento.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
    </VFlow>
  )
}
